import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import { getFormatMessage } from '../../../../utils/formValidation/errorMessageFunctions';
import { validateEmail, validatePhone } from '../../../../utils/formValidation/validationFunctions';
import { regExps } from '../../../../utils/formValidation/validationPatterns';

export const validate = (newEntry, initialStateOnEntry) => {
    let newErrors = {};

    if (newEntry.midwifeName && !regExps.NAME_R.test(newEntry.midwifeName)) {
        newErrors = {
            ...newErrors,
            midwifeName: { error: true, message: getFormatMessage('Name') }
        };
    }

    newErrors = validatePhone(newEntry.midwifePhone, newErrors, 'midwifePhone');
    newErrors = validateEmail(newEntry.midwifeEmail, newErrors, 'midwifeEmail');

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialStateOnEntry);
    return newErrors;
};
